// extracted by mini-css-extract-plugin
export default {"closeButton":"style_closeButton__tAAgt"};